import { routerMiddleware } from "@products/base-portal-lib/middleware";

export default defineNuxtRouteMiddleware(routerMiddleware);
